<script lang="ts">
  import { page } from "$app/stores";

  export let section:
    | {
        title: string;
        pages: {
          href: string;
          title: string;
        }[];
      }
    | { title: string; href: string };

  export let dumbHeader = false;
  export let monoItems = false;
</script>

{#if "href" in section}
  <a
    href={section.href}
    class="header"
    class:active={$page.url.pathname == section.href}
  >
    {section.title}
  </a>
{:else}
  <a href={section.pages.at(0)?.href} class="header" class:dumb={dumbHeader}>
    {section.title}
  </a>
  {#each section.pages as item}
    <a
      href={item.href}
      class="item"
      class:active={$page.url.pathname == item.href}
      class:font-mono={monoItems}>{item.title}</a
    >
  {/each}
{/if}

<style lang="postcss">
  .header {
    @apply text-white text-sm py-2 pl-4 border-l border-white/10 hover:bg-white/5 active:bg-white/10;
  }
  .item {
    @apply text-zinc-400 text-sm py-2 pl-8 pr-2 border-l border-white/10 hover:bg-white/5 active:bg-white/10;
  }
  .active {
    @apply border-primary bg-white/5 font-medium;
  }
  .header.dumb {
    @apply pointer-events-none bg-none;
  }
</style>
